import { render, staticRenderFns } from "./PresentationTable.vue?vue&type=template&id=8585832a"
import script from "./PresentationTable.vue?vue&type=script&lang=js"
export * from "./PresentationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports